// removed by extract-text-webpack-plugin
module.exports = {"root":"Alert__root-1wimL","close":"Alert__close-3WE1v","more":"Alert__more-2uIpx"};